import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClient2x7qc5z8fmeal as HttpClient } from './HttpClient.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { engines_getInstance1g5xg4bwlbqdq as engines_getInstance } from './engine/Loader.mjs';
import { Js_instance2c91gv8g27ea4 as Js_instance } from './engine/js/Js.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_FACTORY() {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return FACTORY;
}
var FACTORY;
function HttpClient_0(block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda;
  } else {
    tmp = block;
  }
  block = tmp;
  _init_properties_HttpClient_web_kt__pyfqvb();
  return HttpClient(get_FACTORY(), block);
}
function HttpClient$lambda(_this__u8e3s4) {
  _init_properties_HttpClient_web_kt__pyfqvb();
  return Unit_instance;
}
var properties_initialized_HttpClient_web_kt_zbb0cl;
function _init_properties_HttpClient_web_kt__pyfqvb() {
  if (!properties_initialized_HttpClient_web_kt_zbb0cl) {
    properties_initialized_HttpClient_web_kt_zbb0cl = true;
    var tmp0 = engines_getInstance();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.u1();
      while (_iterator__ex2g4s.v1()) {
        var element = _iterator__ex2g4s.w1();
        if (!equals(element, Js_instance)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    FACTORY = tmp0_elvis_lhs == null ? Js_instance : tmp0_elvis_lhs;
  }
}
//region block: exports
export {
  HttpClient_0 as HttpClient3584jcajl7sef,
};
//endregion

//# sourceMappingURL=HttpClient.web.mjs.map
